import { formatPhoneNumber } from '@/helpers/formatPhoneNumber'
import { computed, defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'CodeComponent',
  props: {
    timer: {
      type: Number,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    isPhoneHidden: {
      type: Boolean,
      default: true,
    },
    isRegistry: Boolean,
  },
  emits: ['update:code', 'changeClick', 'sendAgainClick'],
  setup(props, { emit }) {
    const value = ref('')

    const hiddenNumber = computed(() => {
      if (!props.phone) {
        return null
      }
      const hiddenPhone = `${props.phone.replace(/^(\d)(\d{6})/, '$1******')}`
      return formatPhoneNumber(hiddenPhone)
    })

    watch(
      () => value.value,
      (newValue) => {
        emit('update:code', newValue)
      },
    )

    return { value, formatPhoneNumber, hiddenNumber }
  },
})
